import { useQuery } from '@tanstack/react-query';
import { searchApi } from '@/lib/api';
import type { SearchParams } from '@arkitekt/shared';

export function useSearch(params: SearchParams | null) {
  return useQuery({
    queryKey: ['search', params],
    queryFn: () => searchApi.search(params!),
    enabled: !!params?.q,
  });
}
